export default __webpack_public_path__ + "static/media/QR.7acc02ab.jpg";